module.exports = __webpack_public_path__ + "img/coupon2022f1.6abd6f5b.jpg";